<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">价格维护</h3>

    <div class="form-container">
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <el-form
        ref="form"
        inline
        disabled
        size="mini"
        label-width="100px"
        :model="wlyBasePricePo"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="product_id" label="产品ID">
              <el-input
                v-model="wlyBasePricePo.product_id"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="prodcut_desc" label="产品描述">
              <el-input v-model="wlyBasePricePo.prodcut_desc" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="zpric_type" label="价格类型">
              <el-select v-model="wlyBasePricePo.zpric_type">
                <el-option
                  v-for="item in selectDataOptions['A0020']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="kbetr" label="价格金额">
              <el-input v-model="wlyBasePricePo.kbetr" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="unit" label="产品单位">
              <el-input v-model="wlyBasePricePo.unit" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="kpein" label="金额单位">
              <el-input v-model="wlyBasePricePo.kpein" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="zzfld00001h" label="营销单元">
              <el-input v-model="wlyBasePricePo.zzfld00001h_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="partner" label="客户编号">
              <el-input
                v-model="wlyBasePricePo.partner"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="name_org1" label="客户名称">
              <el-input
                v-model="wlyBasePricePo.name_org1"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="fdate" label="有效日期起">
              <el-date-picker
                v-model="wlyBasePricePo.fdate"
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="tdate" label="有效日期截止">
              <el-date-picker
                v-model="wlyBasePricePo.tdate"
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="remark" label="备注">
            <el-input
              v-model="wlyBasePricePo.remark"
              type="textarea"
              rows="3"
            />
          </el-form-item>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiGetPriceDetail } from '@/api/sap/client-sap'

export default {
  name: 'price-edit',

  data() {
    return {
      selectDataOptions: {},
      wlyBasePricePo: {
        product_id: '',
        short_text: '',
        zpric_type: '',
        kbetr: '',
        unit: 'CAR',
        unit_text: '盒',
        prodcut_desc: '',
        kpein: 'CNY',
        zzfld00001h: '',
        partner: '',
        name_org1: '',
        fdate: '',
        tdate: '',
        remark: ''
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0020')
    const { id, kotabnr } = this.$route.query
    this.queryData(id, kotabnr)
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async queryData(varnumh, kotabnr) {
      const { data } = await apiGetPriceDetail({ varnumh, kotabnr })
      this.wlyBasePricePo = { ...data }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 15px 15px;
  text-align: left;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/price-manage/components/priceCheck.vue